export default function InLineLabelValue({
    label,
    value,
    parentClass = '',
    labelClassName,
    valueClassName,
    tooltip = false,
    truncate = true,
    button
}) {
    if (!value) return null;

    return (
        <div className={`w-auto ${parentClass}`}>
            <p className={`text-light text-gray-600 text-font11 flex whitespace-nowrap ${labelClassName}`}>
                {label}
                {button}
            </p>
            <p className={`text-light w-full text-font12 text-scogoprimary font-semibold ${valueClassName} ${truncate ? 'line-clamp-2' : 'break-words whitespace-normal'}`}>
                {value}
            </p>
        </div>
    );
}
